// The rodné číslo read the way the tax wizard's server reads it
// (TaxForm::Utils#rodnecislo_valid? and #get_rodne_cislo_age_at_year_and_month
// in lib/tax_form/utils.rb), to guide what can be ticked while it is typed.
// The server checks every answer again; nothing here decides a claim.

// § 33 ods. 1: the child bonus runs to the month of the 18th birthday
// (TaxForm::Rules::MAX_CHILD_AGE_BONUS).
export const MAX_CHILD_AGE_BONUS = 18

// Nine digits for a number issued before 1954, ten after; the month is +50 for
// a woman and +20 for numbers issued since 2004. Ten digits divide by 11 — or,
// before 1986, the first nine leave 10 and the last digit is 0.
// @returns {{ year: number, month: number, day: number } | null}
export function parseRodneCislo(value) {
  const digits = String(value ?? "").replace(/\D/g, "")
  if (digits.length !== 9 && digits.length !== 10) return null

  const shortYear = Number(digits.slice(0, 2))
  let month = Number(digits.slice(2, 4))
  const day = Number(digits.slice(4, 6))
  if (month > 50) month -= 50
  if (month > 20) month -= 20
  const year = digits.length === 9 || shortYear >= 54 ? 1900 + shortYear : 2000 + shortYear

  const date = new Date(Date.UTC(year, month - 1, day))
  if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return null
  if (digits.length === 10 && !checksumValid(digits)) return null

  return { year, month, day }
}

function checksumValid(digits) {
  return Number(digits) % 11 === 0 || (Number(digits.slice(0, 9)) % 11 === 10 && digits[9] === "0")
}

// The age a month of the year is judged by: the birthday month still counts at
// the lower age, a month before the birth is -1.
function ageInMonth(birth, year, month) {
  const age = year - birth.year
  if (month > birth.month) return age
  if (month === birth.month && year === birth.year) return 0
  return age - 1
}

// The months of `taxYear` a child carries a bonus in: from the birth month to
// the month of the 18th birthday.
// @returns {boolean[] | null} twelve flags, January first; null without a valid rodné číslo
export function childBonusMonths(rodneCislo, taxYear) {
  const birth = parseRodneCislo(rodneCislo)
  if (!birth || !Number.isInteger(taxYear)) return null

  return Array.from({ length: 12 }, (_, index) => {
    const age = ageInMonth(birth, taxYear, index + 1)
    return age >= 0 && age < MAX_CHILD_AGE_BONUS
  })
}
